import React from 'react';
import { DashboardModal } from 'containers/Dashboard/components/DashboardModal';
import { Alert, FormGroup, Input, Label } from 'reactstrap';
import __ from 'utils/i18n';

const MAX_BULK_ITEMS = 1000;

export const BulkActionConfirmModal = ({
  showModal = false,
  hideModal,
  action,
  scope,
  onScopeChange,
  pageCount = 0,
  filteredCount = 0,
  submitAction,
  submitDisabled = false,
}) => {
  if (!action) return null;

  const count = scope === 'filtered' ? filteredCount : pageCount;
  const truncated = scope === 'filtered' && filteredCount > MAX_BULK_ITEMS;
  const actionKey = `dashboard.sections.recurringPayments.subscribers.bulk.${action}`;

  return (
    <DashboardModal
      name="bulkSubscriptionActionModal"
      headerText={__(`${actionKey}.title`)}
      showModal={showModal}
      hideModal={hideModal}
      submitAction={submitAction}
      submitColor={action === 'cancel' ? 'danger' : 'primary'}
      submitDisabled={submitDisabled || count === 0}
      hideSeparator={true}
      cancelText={__('dashboard.sections.recurringPayments.subscribers.bulk.cancelButton')}
      submitText={submitDisabled
        ? __('dashboard.sections.recurringPayments.subscribers.bulk.processing')
        : __(`${actionKey}.confirmButton`, { count: truncated ? MAX_BULK_ITEMS : count })}
    >
      <div className="recurring-payments-text-wrap">
        <p className="mb-3">
          {__(`${actionKey}.description`)}
        </p>

        <FormGroup check className="mb-2">
          <Label check>
            <Input
              type="radio"
              name="bulkScope"
              checked={scope === 'page'}
              disabled={pageCount === 0}
              onChange={() => onScopeChange('page')}
            />
            {__('dashboard.sections.recurringPayments.subscribers.bulk.scopePage', { count: pageCount })}
          </Label>
        </FormGroup>
        <FormGroup check className="mb-3">
          <Label check>
            <Input
              type="radio"
              name="bulkScope"
              checked={scope === 'filtered'}
              onChange={() => onScopeChange('filtered')}
            />
            {__('dashboard.sections.recurringPayments.subscribers.bulk.scopeFiltered', { count: filteredCount })}
          </Label>
        </FormGroup>

        {truncated && (
          <Alert color="warning" className="d-flex align-items-start mb-3">
            <i className="mdi mdi-alert mr-2 mt-1" style={{ fontSize: '20px' }} />
            <span>
              {__('dashboard.sections.recurringPayments.subscribers.bulk.truncatedWarning', {
                max: MAX_BULK_ITEMS,
                total: filteredCount,
              })}
            </span>
          </Alert>
        )}

        <Alert color={action === 'cancel' ? 'danger' : 'warning'} className="d-flex align-items-start mb-0">
          <i className="mdi mdi-alert mr-2 mt-1" style={{ fontSize: '20px' }} />
          <span>{__(`${actionKey}.warning`)}</span>
        </Alert>
      </div>
    </DashboardModal>
  );
};
